import React from "react";
import {
    Box,
    Chip,
    Collapse,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Typography,
    Tooltip,
    CircularProgress,
    Divider,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { STATUS } from "../../utils/status";

interface HistoryLog {
    id: number;
    type: string;
    change_aspect: string;
    change_details: Record<string, any>;
    timestamp: string;
    changed_by: string | null;
    request_status: string;
    end_point: string;
    platform: string;
}

interface Props {
    logs: any[];
    count: number;
    page: number;
    rowsPerPage: number;
    openRow: number | null;
    onToggleRow: (id: number) => void;
    onPageChange: (event: unknown, newPage: number) => void;
    onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    getLogsStatus: STATUS
}

const HistorylogsTable: React.FC<Props> = ({
    logs,
    count,
    page,
    rowsPerPage,
    openRow,
    onToggleRow,
    onPageChange,
    onRowsPerPageChange,
    getLogsStatus
}) => {
    const tableColumns = [
        "Type",
        "Change Aspect",
        "Timestamp",
        "Changed By",
        "Details",
    ];
    console.log({ getLogsStatus })
    return (
        <TableContainer sx={{ borderRadius: 2 }}>
            <Table>
                <TableHead>
                    <TableRow>{tableColumns.map((col) => (
                        <TableCell key={col} sx={{ fontFamily: "montserrat", fontWeight: "bold" }}>
                            {col}
                        </TableCell>
                    ))}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {getLogsStatus === STATUS.PENDING ? (<TableRow> <TableCell colSpan={7} align="center" sx={{ py: 3 }}>
                        <div style={{ display: "flex", justifyContent: "center", marginTop: "20px", }}>
                            <CircularProgress />
                        </div> </TableCell> </TableRow>) : logs.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={7} align="center" sx={{ py: 3, fontFamily: "montserrat" }}>
                                    No logs found
                                </TableCell>
                            </TableRow>
                        ) : (
                        logs.map((row) => (
                            <React.Fragment key={row.id}>
                                <TableRow hover>
                                    <TableCell>
                                        <Chip label={row.type}
                                            color={row.type?.toLowerCase() === "stage" ? "primary" : row.type?.toLowerCase() === "config" ? "secondary" : "success"}
                                            variant="outlined"
                                        />
                                    </TableCell>

                                    <TableCell>
                                        <Chip label={row.change_aspect}
                                            color={row.change_aspect?.toLowerCase() === "create" ? "success" : row.change_aspect?.toLowerCase() === "update" ? "warning" : row.change_aspect?.toLowerCase() === "delete" ? "error" : "info"}
                                        />
                                    </TableCell>

                                    <TableCell>{row.timestamp}</TableCell>

                                    <TableCell>{row.changed_by || "System"}</TableCell>

                                    <TableCell>
                                        <IconButton size="small" onClick={() => onToggleRow(row.id)}>
                                            {openRow === row.id ? (<ExpandLessIcon />) : (<ExpandMoreIcon />)}
                                        </IconButton>
                                    </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell colSpan={7} sx={{ p: 0 }}>
                                        <Collapse in={openRow === row.id} timeout="auto" unmountOnExit>
                                            <Paper sx={{ p: 2, m: 2 }}>
                                                <Typography variant="subtitle2" sx={{ fontWeight: "bold", mb: 1, fontFamily: "montserrat", }}>
                                                    Request Payload:
                                                </Typography>
                                                <Tooltip title={<pre style={{ fontFamily: "monospace", fontSize: 12, whiteSpace: "pre-wrap", maxWidth: "600px", }} > {JSON.stringify(row.change_details, null, 2)} </pre>} arrow placement="top-start">
                                                    <pre
                                                        style={{ fontFamily: "monospace", fontSize: 12, whiteSpace: "pre-wrap", cursor: "pointer", }}>
                                                        {JSON.stringify(row.change_details, null, 2).length > 200 ? JSON.stringify(row.change_details, null, 2).slice(0, 200) + "..." : JSON.stringify(row.change_details, null, 2)}
                                                    </pre>
                                                </Tooltip>
<Divider sx={{ my: 2 }} />
                                                <Typography variant="subtitle2"
                                                    sx={{ fontWeight: "bold", mt: 2, mb: 1, fontFamily: "montserrat", }}>
                                                    Response Metadata:
                                                </Typography>
                                                <Tooltip title={<pre style={{ fontFamily: "monospace", fontSize: 12, whiteSpace: "pre-wrap", maxWidth: "600px", }}>
                                                    {JSON.stringify({ status: row.request_status, endpoint: row.end_point, platform: row.platform, }, null, 2)} </pre>
                                                } arrow placement="top-start" >
                                                    <pre
                                                        style={{ fontFamily: "monospace", fontSize: 12, whiteSpace: "pre-wrap", cursor: "pointer", }}>
                                                        {JSON.stringify(
                                                            { status: row.request_status, endpoint: row.end_point, platform: row.platform, }, null, 2).length > 200 ? JSON.stringify(
                                                                { status: row.request_status, endpoint: row.end_point, platform: row.platform, }, null, 2).slice(0, 200) + "..." : JSON.stringify(
                                                                    { status: row.request_status, endpoint: row.end_point, platform: row.platform, }, null, 2)
                                                        }
                                                    </pre>
                                                </Tooltip>
                                            </Paper>
                                        </Collapse>
                                    </TableCell>
                                </TableRow>
                            </React.Fragment>
                        ))
                    )}
                </TableBody>
            </Table>

            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={count}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={onPageChange}
                onRowsPerPageChange={onRowsPerPageChange}
            />
        </TableContainer>
    );
};

export default HistorylogsTable;
